import { ACOES, RECURSOS } from './enums.js';
// Lista canonica de permissoes do sistema. Mantida em sincronia com o seed do db agent.
// O codigo segue o padrao "<recurso>.<acao>" para casamento deterministico em guards.
// Permissoes avulsas (fora do cross-product recurso x acao).
export const PERMISSIONS_EXTRAS = Object.freeze([
    { codigo: 'auditoria.ler', recurso: 'auditoria', acao: 'ler' },
    { codigo: 'notificacoes.ler', recurso: 'notificacoes', acao: 'ler' },
    { codigo: 'notificacoes.enviar', recurso: 'notificacoes', acao: 'enviar' },
    { codigo: 'empresas.gerenciar', recurso: 'empresas', acao: 'gerenciar' },
    { codigo: 'usuarios.gerenciar', recurso: 'usuarios', acao: 'gerenciar' },
    { codigo: 'configuracoes.gerenciar', recurso: 'configuracoes', acao: 'gerenciar' },
]);
export const PERMISSIONS_ALL = (() => {
    const out = [...PERMISSIONS_EXTRAS];
    for (const recurso of RECURSOS) {
        for (const acao of ACOES) {
            // "exportar" so faz sentido para relatorio/ponto
            if (acao === 'exportar' && recurso !== 'relatorio' && recurso !== 'ponto')
                continue;
            // "aprovar" so para ponto/dispositivo/biometria
            if (acao === 'aprovar' &&
                recurso !== 'ponto' &&
                recurso !== 'dispositivo' &&
                recurso !== 'biometria')
                continue;
            out.push({ codigo: `${recurso}.${acao}`, recurso, acao });
        }
    }
    return Object.freeze(out);
})();
export const PERMISSION_CODES = PERMISSIONS_ALL.map((p) => p.codigo);
const todas = () => PERMISSIONS_ALL.map((p) => p.codigo);
const semExclusao = () => PERMISSIONS_ALL.filter((p) => p.acao !== 'excluir').map((p) => p.codigo);
const apenasFuncionario = () => [
    'ponto.criar',
    'ponto.ler',
    'dispositivo.criar',
    'biometria.criar',
    'biometria.ler',
    'funcionario.ler',
    'escala.ler',
    'geofence.ler',
];
const gestorSecretaria = () => [
    'secretaria.ler',
    'secretaria.atualizar',
    'setor.criar',
    'setor.ler',
    'setor.atualizar',
    'setor.excluir',
    'funcionario.criar',
    'funcionario.ler',
    'funcionario.atualizar',
    'funcionario.excluir',
    'biometria.criar',
    'biometria.ler',
    'biometria.atualizar',
    'biometria.aprovar',
    'dispositivo.criar',
    'dispositivo.ler',
    'dispositivo.atualizar',
    'dispositivo.aprovar',
    'escala.criar',
    'escala.ler',
    'escala.atualizar',
    'escala.excluir',
    'geofence.criar',
    'geofence.ler',
    'geofence.atualizar',
    'ponto.ler',
    'ponto.atualizar',
    'ponto.aprovar',
    'ponto.exportar',
    'relatorio.ler',
    'relatorio.exportar',
];
export function permissoesDoRole(role) {
    switch (role) {
        case 'SUPER_ADMIN':
            return todas();
        case 'ADMIN_EMPRESA':
            return semExclusao().filter((c) => 
            // ADMIN_EMPRESA gerencia tudo de sua empresa exceto excluir empresa em si
            !(c === 'empresa.criar' || c === 'empresa.excluir'));
        case 'GESTOR_SECRETARIA':
            return gestorSecretaria();
        case 'FUNCIONARIO':
            return apenasFuncionario();
        default: {
            const _exhaustive = role;
            void _exhaustive;
            return [];
        }
    }
}
//# sourceMappingURL=permissions.js.map